/**
 * @generated SignedSource<<768b6b8f64e72039b33cad95df4706e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Tag",
    "kind": "LinkedField",
    "name": "tags",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionBarTagsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ActionBarTagsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7d96f12b923440be4128c3851fe904ea",
    "id": null,
    "metadata": {},
    "name": "ActionBarTagsQuery",
    "operationKind": "query",
    "text": "query ActionBarTagsQuery {\n  tags {\n    id\n    name\n  }\n}\n"
  }
};
})();

node.hash = "e7751c64517c5dbadbf75a8b5f322106";

module.exports = node;
